import { Injectable } from '@angular/core'

import { HttpService } from './http.service'

import { AppointmentReasonDto, FindAppointmentReason } from '../dto'

@Injectable()
export class AppointmentReasonService {
  constructor(
    private httpService: HttpService) {
  }

  async find(findAppointmentDto: FindAppointmentReason) {
    return await this.httpService.get<AppointmentReasonDto[]>('/admin/appointment-reasons', findAppointmentDto)
  }
}
